import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const DownArrow = createSvgIcon(
  <path d="m19.796 12.296-1.592-1.592-5.079 5.08V3h-2.25v12.783l-5.08-5.079-1.59 1.592L12 20.09l7.796-7.795Z" />,
  'DownArrow'
);

export { DownArrow };
